import defaultPalette from '../palette';
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b;
    return {
        MuiAlert: {
            filledWarning: {
                color: palette.warning.contrastText,
            },
            standardInfo: {
                color: palette.text.primary,
                backgroundColor: palette.background.paper,
                border: "1px solid " + palette.info.main,
            },
            standardWarning: {
                color: palette.text.primary,
                backgroundColor: palette.background.paper,
                border: "1px solid " + palette.vitality.main,
                '& $icon': {
                    color: palette.vitality.main,
                },
            },
            standardError: {
                color: palette.text.primary,
                backgroundColor: palette.background.paper,
                border: "1px solid " + palette.error.main,
            },
        },
    };
});
